import { render, staticRenderFns } from "./RelatoriosExpurgoPropostas.vue?vue&type=template&id=a72afe44&scoped=true&"
import script from "./RelatoriosExpurgoPropostas.vue?vue&type=script&lang=js&"
export * from "./RelatoriosExpurgoPropostas.vue?vue&type=script&lang=js&"
import style0 from "./RelatoriosExpurgoPropostas.vue?vue&type=style&index=0&id=a72afe44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72afe44",
  null
  
)

export default component.exports